module.exports = __webpack_public_path__ + "96fd4007324232e7c10f1126097389a8.jpg";